webpackJsonp([135663918528481],{

/***/ 549:
/***/ (function(module, exports) {

	module.exports = {"data":{"site":{"siteMetadata":{"title":"Nick Long's Blog","subtitle":"Engineer & Musician","copyright":"© Nick Long 2018 All rights reserved.","menu":[{"label":"Articles","path":"/"},{"label":"About me","path":"/about/"}],"author":{"name":"Nick Long","email":"#","telegram":"#","twitter":"monquixote","github":"monquixote","rss":"./rss.xml","vk":"#"}}},"allMarkdownRemark":{"edges":[{"node":{"fields":{"slug":"/the-bible-gets-bad-ass/","categorySlug":"/categories/link/"},"frontmatter":{"title":"The Bible Gets Bad Ass","date":"2007-11-28T20:06:00.000Z","category":"Link","description":null}}}]}},"pathContext":{"tag":"link"}}

/***/ })

});


// WEBPACK FOOTER //
// path---tags-link-daf166268ad50bfae476.js